import { render, staticRenderFns } from "./BracketView.vue?vue&type=template&id=1654d760&"
import script from "./BracketView.vue?vue&type=script&lang=js&"
export * from "./BracketView.vue?vue&type=script&lang=js&"
import style0 from "./BracketView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports